import Paper from '@material-ui/core/Paper';
import { createStyles, makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import React, { FC, ReactElement } from 'react';
import NoRecords from 'src/components/NoRecords';
import { Theme } from 'src/theme';

type dataAlign = 'left' | 'right' | 'inherit' | 'center' | 'justify';
interface RowColor {
  text: string;
  backGround: string;
}
interface BasicTableProps {
  headings?: string[];
  rows?: (string | number | ReactElement)[][];
  dataAlign?: dataAlign;
  colsWidth?: string[];
  headerColor?: RowColor;
  oddRowColor?: RowColor;
  evenRowColor?: RowColor;
}
const useStyles = makeStyles((theme: Theme) => ({
  table: {
    minWidth: 300,
  },
  tableRow: {
    '&:hover': {
      backgroundColor: `${theme.customs.transaction.whisper}!important`
    }
  }
}));

const BasicTableColorable: FC<BasicTableProps> = ({ headings = [], rows = [], dataAlign = 'left', colsWidth = [], headerColor = null, oddRowColor = null, evenRowColor = null }) => {

  const classes = useStyles();

  const StyledTableHead = withStyles((theme: Theme) =>
    createStyles({
      root: {
        backgroundColor: headerColor ? headerColor.backGround : 'none',
        color: headerColor ? headerColor.text : 'none',
      },
    }),
  )(TableHead);

  const StyledTableCellHeader = withStyles((theme: Theme) =>
    createStyles({
      root: {
        backgroundColor: headerColor ? headerColor.backGround : 'none',
        color: headerColor ? headerColor.text : 'none',
      },
    }),
  )(TableCell);

  const StyledTableRow = withStyles((theme: Theme) =>
    createStyles({
      root: {
        '&:nth-of-type(odd)': {
          backgroundColor: oddRowColor.backGround,
        },
        '&:nth-of-type(even)': {
          backgroundColor: evenRowColor.backGround,
        },
      },
    }),
  )(TableRow);

  const StyledTableCellData = withStyles((theme: Theme) =>
    createStyles({
      root: {}
    }),
  )(TableCell);

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} size="small" aria-label="a dense table">
      {colsWidth ? <colgroup>
            {colsWidth.map((width, i) => {
              return <col key={i} span={1} style={{ width }} />;
            })}
          </colgroup> : ''}
        {headings?.length ? <StyledTableHead>
          <TableRow>
            {headings.map((heading, i) => {
              return (<StyledTableCellHeader align={i === 0 ? 'left' : 'center'} > {heading}</StyledTableCellHeader>);
            })}
          </TableRow>
        </StyledTableHead> : ''}

        {rows?.length ? <TableBody>
          {rows.map((row, k) => {
            return <StyledTableRow hover className={classes.tableRow} key={k}>
              {Object.keys(row).map((key, i) => {
                return <StyledTableCellData align={i === 0 ? 'left' : dataAlign as dataAlign} component={i === 0 ? 'th' : 'td'} scope={i === 0 ? 'row' : ''}>
                  {row[key]}
                </StyledTableCellData>;
              })}
            </StyledTableRow>;
          })}
        </TableBody>
          :
          <TableBody >
            <StyledTableRow>
              <StyledTableCellData align="center" colSpan={10}>
                <NoRecords text="No Records Found" variant={'h3'} color={'textSecondary'} />
              </StyledTableCellData>
            </StyledTableRow>
          </TableBody>
        }
      </Table>
    </TableContainer >
  );
};

export default BasicTableColorable;
